import { styled } from "@mui/system";
import Box from "@mui/material/Box";

export const StyledMainWrapper = styled(Box)(() => ({
  maxWidth: "600px",
  margin: "0 auto",
  textAlign: "center",
  paddingTop: "80px",
}));
